import React from "react";

interface UnsplashAttributionProps {
  photographerName: string;
  photographerUsername: string;
  photoId: string;
  photoTitle?: string;
  compact?: boolean;
}

export const UnsplashAttribution: React.FC<UnsplashAttributionProps> = ({
  photographerName,
  photographerUsername,
  photoId,
  photoTitle,
  compact = false
}) => {
  const photoUrl = `https://unsplash.com/photos/${photoId}`;
  const profileUrl = `https://unsplash.com/@${photographerUsername}`;

  if (compact) {
    return (
      <div
        style={{
          fontSize: "0.65rem",
          color: "rgba(148, 163, 184, 0.7)",
          display: "flex",
          alignItems: "center",
          gap: "0.25rem",
          flexWrap: "wrap"
        }}
      >
        <span>Photo by</span>
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "rgba(148, 163, 184, 0.9)",
            textDecoration: "none",
            fontWeight: 500
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = "underline";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = "none";
          }}
        >
          {photographerName}
        </a>
        <span>on</span>
        <a
          href="https://unsplash.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "rgba(148, 163, 184, 0.9)",
            textDecoration: "none",
            fontWeight: 500
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = "underline";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = "none";
          }}
        >
          Unsplash
        </a>
      </div>
    );
  }

  return (
    <div
      style={{
        fontSize: "0.7rem",
        color: "rgba(148, 163, 184, 0.8)",
        display: "flex",
        flexDirection: "column",
        gap: "0.2rem",
        padding: "0.5rem",
        background: "rgba(15, 23, 42, 0.3)",
        borderRadius: 6,
        border: "1px solid rgba(148, 163, 184, 0.1)"
      }}
    >
      {photoTitle && (
        <div style={{ fontWeight: 500, marginBottom: "0.15rem" }}>{photoTitle}</div>
      )}
      <div style={{ display: "flex", alignItems: "center", gap: "0.3rem", flexWrap: "wrap" }}>
        <span>Photo by</span>
        <a
          href={profileUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "rgba(148, 163, 184, 0.95)",
            textDecoration: "none",
            fontWeight: 500
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = "underline";
            e.currentTarget.style.color = "rgba(203, 213, 225, 1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = "none";
            e.currentTarget.style.color = "rgba(148, 163, 184, 0.95)";
          }}
        >
          {photographerName}
        </a>
        <span>on</span>
        <a
          href="https://unsplash.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "rgba(148, 163, 184, 0.95)",
            textDecoration: "none",
            fontWeight: 500
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.textDecoration = "underline";
            e.currentTarget.style.color = "rgba(203, 213, 225, 1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.textDecoration = "none";
            e.currentTarget.style.color = "rgba(148, 163, 184, 0.95)";
          }}
        >
          Unsplash
        </a>
      </div>
      <a
        href={photoUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          fontSize: "0.65rem",
          color: "rgba(148, 163, 184, 0.7)",
          textDecoration: "none",
          marginTop: "0.1rem"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.textDecoration = "underline";
          e.currentTarget.style.color = "rgba(148, 163, 184, 0.9)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.textDecoration = "none";
          e.currentTarget.style.color = "rgba(148, 163, 184, 0.7)";
        }}
      >
        View original photo →
      </a>
    </div>
  );
};

